
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import DeptCategoryForm from '../components/forms/DeptCategoryForm';
import '../styles/EmployeeMaster.css';
import DeptCategoryTable from '../components/DeptCategoryTable';

const DeptCategoryModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/deptcategory/add';

  const handleAddClick = () => {
    navigate('/deptcategory/add');
  };

  const handleCloseModal = () => {
    navigate('/deptcategory');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Dept Category Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Dept Category
        </button>
      </div>

      <DeptCategoryTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Dept Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeptCategoryForm />
        </Modal.Body>
        
      </Modal>
    </div>
  );
};

export default DeptCategoryModel;
